var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"behaviorChart"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.source.index))]),_c('div',{staticClass:"flexbox"},[_c('div',{staticClass:"myChart",attrs:{"id":_vm.source.id}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }